var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "studip-tree-breadcrumb contentbar",
    },
    [
      _c("nav", {
        staticClass: "contentbar-nav",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "contentbar-wrapper-left": true,
            "with-navigation": _vm.showNavigation,
            editable: _vm.editable,
            "with-navigation-and-editable": _vm.showNavigation && _vm.editable,
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.icon,
              size: 24,
            },
          }),
          _vm._v(" "),
          _vm.node.attributes.ancestors
            ? _c(
                "nav",
                {
                  staticClass: "studip-tree-breadcrumb-list contentbar-nav",
                },
                _vm._l(
                  _vm.node.attributes.ancestors,
                  function (ancestor, index) {
                    return _c(
                      "span",
                      {
                        key: ancestor.id,
                      },
                      [
                        _c(
                          "a",
                          {
                            ref: ancestor.id,
                            refInFor: true,
                            attrs: {
                              href: _vm.nodeUrl(
                                ancestor.classname + "_" + ancestor.id
                              ),
                              tabindex: "0",
                              id: "tree-breadcrumb-" + ancestor.id,
                              title: _vm.$gettextInterpolate(
                                _vm.$gettext("%{ node } öffnen"),
                                {
                                  node: ancestor.name,
                                },
                                true
                              ),
                            },
                            on: {
                              click: function click($event) {
                                $event.preventDefault()
                                return _vm.openNode(
                                  ancestor.id,
                                  ancestor.classname
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ancestor.name) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        index !== _vm.node.attributes.ancestors.length - 1
                          ? [
                              _vm._v(
                                "\n                    /\n                "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "contentbar-wrapper-right",
        },
        [
          _vm.showNavigation
            ? _c(
                "div",
                {
                  staticClass: "studip-tree-navigation-wrapper",
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        tabindex: "0",
                        title: _vm.navigationOpen
                          ? _vm.$gettext("Navigation schließen")
                          : _vm.$gettext("Navigation öffnen"),
                        "aria-expanded": _vm.navigationOpen,
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.toggleNavigation.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "table-of-contents",
                          size: 24,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.navigationOpen
                    ? _c(
                        "article",
                        {
                          staticClass: "studip-tree-navigation",
                        },
                        [
                          _c("header", [
                            _c("h1", [_vm._v(_vm._s(_vm.$gettext("Inhalt")))]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                attrs: {
                                  type: "button",
                                  tabindex: "0",
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.toggleNavigation.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "decline",
                                    size: 24,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("studip-tree-node", {
                            attrs: {
                              "with-info": false,
                              node: _vm.rootNode,
                              "active-node": _vm.node,
                              "open-nodes": [_vm.node.id],
                              "visible-children-only": _vm.visibleChildrenOnly,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assignable
            ? _c(
                "button",
                {
                  staticClass: "assign-button",
                  attrs: {
                    type: "submit",
                    title: _vm.$gettext("Diesen Eintrag zuweisen"),
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "arr_2right",
                      size: 20,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editable
            ? _c("studip-action-menu", {
                attrs: {
                  items: _vm.actionMenuItems(),
                },
                on: {
                  "add-tree-node": _vm.addNode,
                  "edit-tree-node": _vm.editNode,
                  "delete-tree-node": _vm.deleteNode,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }